import { render, staticRenderFns } from "./addRoomRepairList.vue?vue&type=template&id=faca7e88&scoped=true"
import script from "./addRoomRepairList.vue?vue&type=script&lang=js"
export * from "./addRoomRepairList.vue?vue&type=script&lang=js"
import style0 from "./addRoomRepairList.vue?vue&type=style&index=0&id=faca7e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faca7e88",
  null
  
)

export default component.exports